module.exports = __webpack_public_path__ + "media/images/emblems/Mettmenstetten-blazon-2be554fc2d4f75983d1e2f250612053a.svg";